import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';
// @ts-expect-error
import type {SingleValueProps, OptionProps} from 'react-select';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ReplyAllIcon} from 'shells/icon/svg/reply-all-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ReplyIcon} from 'shells/icon/svg/reply-icon';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import styles from './reply-button-field.module.css';

type OwnProps = FieldProps & {
    isMultiSequence: boolean;
    isDisabled: boolean;
    onSubjectChange?: (arg1: string) => void;
};

type Props = FieldProps & OwnProps;

type State = {
    value: string;
};

export class ReplyButtonField extends React.Component<Props, State> {
    render() {
        const optionReplyAll = {value: true, label: 'Reply all'} as const;
        const optionReply = {value: false, label: 'Reply'} as const;

        return (
            <div className={styles.container}>
                <SelectPickerGeneric
                    options={[optionReply, optionReplyAll]}
                    value={this.props.input.value ? optionReplyAll : optionReply}
                    // @ts-expect-error
                    onChange={(newValue) => {
                        this.props.input.onChange(newValue.value);
                    }}
                    styles={{
                        // @ts-expect-error
                        control: (base) => ({...base, height: 24, minHeight: 24}),
                        // @ts-expect-error
                        valueContainer: (base) => ({...base, marginTop: -4}),
                        // @ts-expect-error
                        dropdownIndicator: (base) => ({...base, marginTop: -4}),
                    }}
                    components={{
                        Option: OptionComponent,
                        SingleValue: SingleValueComponent,
                    }}
                />
            </div>
        );
    }
}

const SingleValueComponent = (props: SingleValueProps) => {
    return (
        <components.SingleValue {...props}>
            <CustomOptionComponent {...props} />
        </components.SingleValue>
    );
};

const OptionComponent = (props: OptionProps) => {
    return (
        <components.Option {...props}>
            <CustomOptionComponent {...props} />
        </components.Option>
    );
};

const CustomOptionComponent = (props: {
    data: {
        value: boolean;
    };
}) => (
    <div className={styles['option-container']}>
        {props.data.value ? (
            <div className={styles['reply-all-container']}>
                <ReplyAllIcon size={12} fill={colors.greyLt} />
            </div>
        ) : (
            <ReplyIcon size={12} fill={colors.greyLt} />
        )}
        {props.data.value ? 'Reply all' : 'Reply'}
    </div>
);
